import { defineComponent as _defineComponent } from 'vue'
import type { WebLocale } from '@/enums/web-locale';
import type { SnowplowContext } from '@/helpers/tracking/providers';

import CountryListItem from '@/components/modals/country-list/CountryListItem.vue';
import SearchBar from '@/features/search/components/SearchBar.vue';

import { WEB_LOCALES } from '@/constants/web-locales.constant';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router/composables';
import { useI18n } from '@/helpers/composables/useI18n';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryList',
  props: {
    additionalContexts: { default: () => [] }
  },
  emits: ["selected-country"],
  setup(__props: any, { emit }: { emit: ({ (e: 'selected-country', webLocale: WebLocale): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { additionalContexts: SnowplowContext[] };





const languageStore = useLanguageStore();
const routingStore = useRoutingStore();

const { tc } = useI18n();

const router = useRouter();

const search = ref('');

const localesWithPages = computed<Record<string, string>>(() =>
	Object.fromEntries((routingStore.urlMetadata?.allHrefLangTags ?? []).map(tl => [tl.href.slice(1, 3), tl.href]))
);

const availableWebLocale = computed(() =>
	languageStore.locales.some(locale => locale.webLocale === languageStore.webLocale) ? languageStore.webLocale : ''
);

const webLocales = computed(() => {
	const filteredLocales = languageStore.locales
		.filter(locale => {
			if (!(locale.webLocale in localesWithPages.value)) return false;
			if (!search.value) return true;

			return Object.values(locale.country_names)
				.map(name => name.toLowerCase())
				.concat(locale.country.toLowerCase())
				.some(name => name.includes(search.value.toLowerCase()));
		})
		.map(locale => locale.webLocale);

	return filteredLocales.sort((a, b) =>
		tc(`WEBAPP_COUNTRY_${a.toUpperCase()}`).localeCompare(tc(`WEBAPP_COUNTRY_${b.toUpperCase()}`))
	);
});

async function selectWebLocale(selectedLocale: WebLocale) {
	if (selectedLocale === languageStore.webLocale) return;

	const path = localesWithPages.value[selectedLocale];
	if (path == null) return;

	const localeString = WEB_LOCALES[selectedLocale] || '';
	const language = localeString.substring(0, 2);

	await languageStore.setWebLocale(selectedLocale);
	await languageStore.setLanguageWhenUserDidNot(language);

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'country_selector_toggled',
			property: selectedLocale,
		},
		props.additionalContexts
	);

	await router.push({ path });
	emit('selected-country', selectedLocale);
}

return { __sfc: true,props, emit, languageStore, routingStore, tc, router, search, localesWithPages, availableWebLocale, webLocales, selectWebLocale, CountryListItem, SearchBar }
}

})